import React, { useContext, useEffect, useState } from 'react';
import AppContext from '../../../../App/AppContext';
import { CircularProgress, FormHelperText, Grid, InputLabel, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { SecondaryButton, SingelSelect } from '../../../../Core/FormInput';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { getPartReqRenaultStatus } from '../../../../Core/Service/PartReq_services/partReq-service';
import { PostGridPartReqs_UpdateStatus } from '../../../../Core/Service/PartReq_services/partReturnSteps-services';

const StyledTableCell = withStyles((theme) => ({
    head: {
        // padding: ' 5px',
        fontSize: 15,
        fontWeight: 600,
        backgroundColor: '#bdbdbd82'
    },
    body: {
        fontSize: 12
        // padding: ' 5px'
        // fontSize: 11,
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:hover': {
            backgroundColor: 'grey',
            color: 'white'
        },
        cursor: 'pointer'
    }
}))(TableRow);

const ChangePartStatusModal = (props) => {
    const { showToast } = useContext(AppContext);
    const [btnLoader, setBtnLoader] = useState(false);
    const [state, setState] = useState({
        partReqIds: [],
        errors: {},
        dropDownRes: []
    });

    const PullDate = async () => {
        let dropDownRes = await getPartReqRenaultStatus();
        if (dropDownRes.success) {
            setState((st) => ({ ...st, dropDownRes: dropDownRes.data.partReqStatus }));
        }
    };

    useEffect(async () => {
        await PullDate();
        if (props.selectedRecords.length > 0) {
            setState((st) => ({ ...st, partReqIds: props.selectedRecords.map((q) => q.partReqID) }));
        }
    }, []);

    const singleSelectChange = (nm) => async (ev, val) => {
        let value = val ? val.id : '';
        setState((st) => ({
            ...st,
            [nm]: value,
            errors: { ...st.errors, [nm]: value ? '' : 'This field is required' }
        }));
    };

    const handleValidation = () => {
        let errors = {};
        let formIsValid = true;

        if (!state.partStatus) {
            formIsValid = false;
            errors['partStatus'] = 'Please select status';
        }
        // if (!state.workflowVal?.id) {
        //     formIsValid = false;
        //     errors['workflowVal'] = 'Please select workflow';
        // }
        // if (!state.returnReasonVal?.id) {
        //     formIsValid = false;
        //     errors['returnReasonVal'] = 'Please select return reason';
        // }

        setState((prevState) => ({
            ...prevState,
            errors: errors
        }));
        return formIsValid;
    };

    const Onsubmit = async () => {
        if (handleValidation()) {
            setBtnLoader(true);
            let data = {
                partReqIds: state.partReqIds,
                partStatus: state.partStatus
            };

            let res = await PostGridPartReqs_UpdateStatus(data);

            if (res.success) {
                showToast(res?.data?.message);
                props.onClose && props.onClose(true);
            }
            setBtnLoader(false);
        }
    };

    console.log('state', props.selectedRecords);

    return (
        <div>
            {state.partReqIds.length <= 0 ? (
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Alert severity="info">Please Select parts </Alert>
                    </Grid>
                </Grid>
            ) : (
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <InputLabel shrink style={{ marginBottom: '-8px' }}>
                            Status
                        </InputLabel>
                        <SingelSelect options={state.dropDownRes} value={state.partStatus} onChange={singleSelectChange('partStatus')} name="partStatus" />
                        <FormHelperText error>{state.errors?.partStatus}</FormHelperText>
                    </Grid>
                    <Grid item xs={12}>
                        {btnLoader ? (
                            <SecondaryButton fullWidth>
                                <CircularProgress size={25} />
                            </SecondaryButton>
                        ) : (
                            <SecondaryButton fullWidth onClick={Onsubmit} isBtnLoader={btnLoader}>
                                Submit{' '}
                            </SecondaryButton>
                        )}
                    </Grid>
                    <Grid item xs={12}>
                        <TableContainer style={{ height: '300px' }}>
                            <Table size="small" width="550px" stickyHeader>
                                <TableHead>
                                    <TableRow className="header">
                                        <StyledTableCell>Reg No</StyledTableCell>
                                        <StyledTableCell>Job No</StyledTableCell>
                                        <StyledTableCell>Customer</StyledTableCell>
                                        <StyledTableCell>Main Part</StyledTableCell>
                                        <StyledTableCell>Supplier</StyledTableCell>
                                        <StyledTableCell>ETA for parts ordered</StyledTableCell>
                                        {/* <StyledTableCell>Returned By</StyledTableCell> */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {props.selectedRecords.map((q) => {
                                        return (
                                            <StyledTableRow>
                                                <StyledTableCell>{q.regNo}</StyledTableCell>
                                                <StyledTableCell>{q.wipNo}</StyledTableCell>
                                                <StyledTableCell>{q.cust}</StyledTableCell>
                                                <StyledTableCell>{q.mainPart}</StyledTableCell>
                                                <StyledTableCell>{q.partReqSupplier}</StyledTableCell>
                                                <StyledTableCell>{q.partReqETA}</StyledTableCell>
                                                {/* <StyledTableCell>{q.returnedBy}</StyledTableCell> */}
                                            </StyledTableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>
            )}
        </div>
    );
};

export default ChangePartStatusModal;
